import React from 'react';
import { Typography } from 'antd';
import {
  UserOutlined,
  PhoneOutlined,
  BankOutlined,
  SafetyCertificateOutlined,
  EnvironmentOutlined,
  GlobalOutlined
} from '@ant-design/icons';
import styles from './Template.module.css';

const { Title, Text } = Typography;

const Template1 = ({ data, templateType }) => {
  const {
    company,
    name,
    position,
    phone,
    supervisionPhone,
    location,
    serviceArea
  } = data;

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <Text strong style={{ fontSize: 18, color: '#fff' }}>{name}的电子名片</Text>
      </div>
      <div className={styles.cardBody}>
        <div className={`${templateType === 1 ? styles.template1 : templateType === 2 ? styles.template2 : styles.template3} ${styles.cardContent}`}>
          <div className={styles.name}>{name}</div>
          <div className={styles.positionAndphone}>
            <div className={styles.position}>{position}</div>
            <div className={styles.phone}>{phone}</div>
          </div>
          <div className={styles.company}>{company}</div>
          <div className={styles.supervisionPhone}>监督电话：{supervisionPhone}</div>
        </div>
        <div className={styles.otherInfo}>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle}>单位：</div>
            <div className={styles.otherInfoItemContent}>{company}</div>
          </div>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle}>姓名：</div>
            <div className={styles.otherInfoItemContent}>{name}</div>
          </div>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle}>职位：</div>
            <div className={styles.otherInfoItemContent}>{position}</div>
          </div>
          <div className={styles.otherInfoItem} style={{ position: 'relative' }}>
            <div className={styles.otherInfoItemTitle}>电话：</div>
            <div className={styles.otherInfoItemContent}>{phone}</div>
            <div className={styles.btnbg}>拨打电话</div>
          </div>
          <div className={styles.otherInfoItem} style={{ position: 'relative' }}>
            <div className={styles.otherInfoItemTitle}>监督电话：</div>
            <div className={styles.otherInfoItemContent}>{supervisionPhone}</div>
            <div className={styles.btnbg}>拨打电话</div>
          </div>
          <div className={styles.otherInfoItem} style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
            <div className={styles.otherInfoItemTitle} style={{ marginBottom: 19 }}>营业所站地址：</div>
            <div className={styles.otherInfoItemContent}>{location.address}</div>
            <div className={styles.btnbg}>地图导航</div>
          </div>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle}>服务范围：</div>
          </div>
          <div className={styles.otherInfoItem}>
            <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
              {serviceArea?.split("、")?.map(item => <div style={{ width: '50%', color: '#666', fontSize: '12px' }} key={item}>{item}</div>)}
            </div>
          </div>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle}>温馨提示：</div>
          </div>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle} style={{ color: '#666', fontSize: '12px' }}>
              尊敬的电力客户，您好!<br></br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我是您的专属电管家，若您有电力报装、电价电费、用电变更、政策咨询、停电报修等用电业务欢迎及时联系我，我将竭诚为您服务。祝您幸福安康、生活愉快!
            </div>
          </div>
          <div className={styles.otherInfoItem}>
            <div className={styles.otherInfoItemTitle}>扫码关注：</div>
          </div>
          <div className={styles.otherInfoItem}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}>
              <div style={{ width: 107, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img style={{ width: 107, height: 104, marginBottom: 10 }} src={require('@assets/images/mdej.png')} alt="" />
                <div style={{ fontSize: 12, color: '#008D6A' }}>蒙电e家</div>
              </div>
              <div style={{ width: 107, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img style={{ width: 107, height: 104, marginBottom: 10 }} src={require('@assets/images/gzh.png')} alt="" />
                <div style={{ fontSize: 12, color: '#008D6A' }}>微信公众号</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardFooter}>
        <div>存通讯录</div>
        <div>转发名片</div>
      </div>
    </div>
  );
};

export default Template1; 